import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import Philosophy from '../components/home/Philosophy';
import FeatureGrid from '../components/home/FeatureGrid';
import Stats from '../components/home/Stats';
import Schedules from '../components/home/Schedules';
import Feedback from '../components/home/Feedback';
import CTA from '../components/home/CTA';
import MathBackground from '../components/layout/MathBackground';

const Home = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
                delayChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
        }
    };

    return (
        <div className="bg-[#0a0a0a] text-white font-inter selection:bg-blue-500/30 overflow-x-hidden relative">
            <MathBackground />
            <Navbar />

            <Hero
                containerVariants={containerVariants}
                itemVariants={itemVariants}
            />

            <Philosophy />

            <FeatureGrid />

            <Stats />

            <Schedules />

            <Feedback />

            <CTA />

            <Footer />

            {/* Global Style Inject for Spin Slow */}
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes spin-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                .animate-spin-slow {
                    animation: spin-slow 12s linear infinite;
                }
                `
            }} />
        </div>
    );
};

export default Home;
